import React, { ReactNode } from 'react';
import GlobalProps from '../../globalProps';
import classnames from 'classnames';

import './Label.css';

interface Props extends GlobalProps {
  title: string | ReactNode;
  actions?: ReactNode;
}

export function Label({ title, actions, className, style }: Props): JSX.Element {
  return (
    <div className={classnames('label', className)}>
      <label style={style} className="label__title">
        {title}
      </label>
      {actions}
    </div>
  );
}
